import { Injectable } from '@angular/core';
import { Address, ERC20, ERC20__factory } from '@31third/common';
import { TransactionService } from './transaction.service';
import {
  MAX_WEI,
  SignerService,
  Token,
  Transaction,
  TransactionType,
} from 'common';
import { ContractTransactionResponse } from 'ethers';

// TODO: refactor tx service and move to common
@Injectable({
  providedIn: 'root',
})
export class Erc20Service {
  constructor(
    private signerService: SignerService,
    private transactionService: TransactionService,
  ) {}

  public async approve(
    token: Token,
    target: Address,
    value = MAX_WEI, // max approval
  ): Promise<Transaction> {
    const contract = await this.getContractForAddress(token.address);
    const estimatedGas = await contract.approve.estimateGas(target, value);
    const tx: ContractTransactionResponse | undefined = await contract.approve(
      target,
      value,
      {
        gasLimit: (estimatedGas * 120n) / 100n, // add 20% gas buffer
      },
    );

    if (!tx) {
      throw new Error(`Couldn't approve ${token.name}`);
    }

    const transaction = new Transaction(
      tx,
      `Approving ${token.name} for trading.`,
      TransactionType.APPROVE,
    );
    await this.transactionService.addTransaction(transaction, token.address);

    return Promise.resolve(transaction);
  }

  public async getContractForAddress(address: Address): Promise<ERC20> {
    return ERC20__factory.connect(address, this.signerService.getSigner());
  }
}
